import * as React from 'react';
import { FormControl, FormHelperText, InputLabel, MenuItem, Select } from '@mui/material';

export interface StatesSelectProps {
  label: String;
  variant: 'filled' | 'standard' | 'outlined' | undefined;
  fullWidth: boolean;
  size: 'small' | 'medium' | undefined;
  value: String;
  onChange: Function;
  error: boolean;
  helperText: String | null | undefined;
  disabled: boolean;
}

export const StatesSelect: React.FC<StatesSelectProps> = (props) => {
  const { label, variant, fullWidth, size, value, onChange, error, helperText, disabled } = props;

  // prettier-ignore
  const stateAbbreviations = [
    'AL','AK','AZ','AR','CA','CO','CT','DE','DC','FL',
    'GA','HI','ID','IL','IN','IA','KS','KY','LA','ME',
    'MD','MA','MI','MN','MS','MO','MT','NE','NV','NH',
    'NJ','NM','NY','NC','ND','OH','OK','OR','PA','RI',
    'SC','SD','TN','TX','UT','VT','VA','WA','WV','WI','WY'
  ];

  return (
    <div>
      <FormControl fullWidth size={size}>
        <InputLabel id="state">State</InputLabel>
        <Select
          id="state"
          value={value}
          label={label}
          variant={variant}
          fullWidth={fullWidth}
          size={size}
          error={error}
          disabled={disabled}
          onChange={(event: any) => {
            onChange(event);
          }}
        >
          <MenuItem value="">
            <em>State</em>
          </MenuItem>
          {stateAbbreviations.map((state) => (
            <MenuItem key={state} value={state}>
              {state}
            </MenuItem>
          ))}
        </Select>
        <FormHelperText error>{helperText}</FormHelperText>
      </FormControl>
    </div>
  );
};
